import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    const isRequestForOurServer = req.url.startsWith(environment.backendDomain);
    if (!isRequestForOurServer) {
      return next.handle(req);
    } else {
      if (req.body instanceof FormData) {
        // set headers for pdf upload
        req = req.clone({
          setHeaders: {
            Authorization: 'Bearer ' + localStorage.getItem('token'),
          },
        });

        return next.handle(req);
      } else {
        req = req.clone({
          setHeaders: {
            'Content-Type': 'application/json; charset=utf-8',
            Accept: 'application/json',
            Authorization: 'Bearer ' + localStorage.getItem('token'),
          },
        });

        return next.handle(req);
      }
    }
  }
}
